<ng-container *ngFor="let submenu of submenus">
  <div class="main-menu__submenu-item" *ngIf="submenu.items.length">
    <span *ngIf="submenu.label">{{ submenu.label }}</span>
    <div class="main-menu__submenu-links">
      <app-menu-link
        *ngFor="let link of submenu.items"
        styleClass="submenu-link"
        [item]="link"
        (click)="onClick(link)"
      ></app-menu-link>
    </div>
  </div>
</ng-container>
